// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"Badges-module--badge-container--3owXk","badgeRow":"Badges-module--badge-row--3WWOr"};